var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-alert',{staticStyle:{"margin":"20px 0"},attrs:{"showIcon":"","message":"Konto lektora jest nieaktywne. Nie można dodać do niego dostępności, oraz nie ma on dostępu do panelu.","type":"warning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }